module.exports = __webpack_public_path__ + "static/media/lunch062023.e5b65ca3.pdf";